module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/83f752b990fd8a9b008deb17e4f3698d.png";